module.exports = __webpack_public_path__ + "img/vg.e4b5415e.svg";